module.exports = __webpack_public_path__ + "static/media/43_tn.c3253833.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/black/thumbnails/43_tn.jpg
// module id = 256
// module chunks = 0